import moment from "moment";

export function formatOfflineDuration(a, b) {
  if (!a) return "";

  let target;
  if (b) {
    // Called as formatOfflineDuration(dateStr, timeStr), e.g. ("02 Jul", "5:09 pm")
    target = moment(`${a} ${b}`, "DD MMM h:mm a");
  } else {
    // Called as formatOfflineDuration(fullTimestamp)
    // Handles plain ISO strings, "YYYY-MM-DD HH:mm:ss", and the pump's
    // "YYYY-MM-DD HH:mm:ss IST+0530" format (strip everything from " IST" onward).
    const cleaned = String(a).split(" IST")[0];
    target = moment(cleaned, ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
    if (!target.isValid()) {
      target = moment(cleaned);
    }
  }

  if (!target.isValid()) return "";

  if (target.isAfter(moment())) {
    target.subtract(1, "year");
  }

  const diffMs = moment().diff(target);
  if (diffMs < 0) return "just now";

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return `${seconds}s ago`;
  if (minutes < 60) {
    const remSeconds = seconds % 60;
    return remSeconds > 0 ? `${minutes}m ${remSeconds}s ago` : `${minutes}m ago`;
  }
  if (hours < 24) {
    const remMinutes = minutes % 60;
    return remMinutes > 0 ? `${hours}h ${remMinutes}m ago` : `${hours}h ago`;
  }
  const remHours = hours % 24;
  const remMinutes = minutes % 60;
  let result = `${days}d`;
  if (remHours > 0) result += ` ${remHours}h`;
  if (remMinutes > 0) result += ` ${remMinutes}m`;
  return `${result} ago`;
}